module.exports = __webpack_public_path__ + "img/1499657406.a6a55771.jpg";